import React, { useState, useEffect } from 'react';
import { Hook, Console, Decode } from 'console-feed'

const SRGConsole = () => {
  const [consoleMessages, setConsoleMessages] = useState([]);

  useEffect(() => {
    Hook(window.console, log => {
      setConsoleMessages(previousMessages => [...previousMessages, Decode(log)]);
    })
  }, []);

  return (
    <>
      <h1 className="content__title console-title">Debug Console <button onClick={() => setConsoleMessages([])}>Clear</button></h1>
      <div className="console">
        <Console logs={consoleMessages} variant="dark" filter={['log']} />
      </div>
    </>
  );
};

export default SRGConsole;
